module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tasks-tab"
    }
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row background-white"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel-content-inner w-full"
  }, [_c('div', {
    staticClass: "row d-flex justify-content-around"
  }, [_c('div', {
    staticClass: "jobs-desc text-center"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.statusCounts.toBeAssigned))]), _vm._v(" "), _c('span', {
    staticClass: "desc desc-be-assigned"
  }, [_vm._v(_vm._s(_vm.getStatusName(1) ? _vm.getStatusName(1) : _vm.$t('calendar.jobs.to_be_assigned')))])]), _vm._v(" "), _c('div', {
    staticClass: "jobs-desc text-center"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.statusCounts.assigned))]), _vm._v(" "), _c('span', {
    staticClass: "desc desc-assigned"
  }, [_vm._v(_vm._s(_vm.getStatusName(2) ? _vm.getStatusName(2) : _vm.$t('calendar.jobs.assigned')))])]), _vm._v(" "), _c('div', {
    staticClass: "jobs-desc text-center"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.statusCounts.done))]), _vm._v(" "), _c('span', {
    staticClass: "desc desc-done"
  }, [_vm._v(_vm._s(_vm.getStatusName(3) ? _vm.getStatusName(3) : _vm.$t('calendar.jobs.done')))])]), _vm._v(" "), _c('div', {
    staticClass: "jobs-desc text-center"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.statusCounts.inProgress))]), _vm._v(" "), _c('span', {
    staticClass: "desc desc-cleaning"
  }, [_vm._v(_vm._s(_vm.getStatusName(4) ? _vm.getStatusName(4) : _vm.$t('calendar.jobs.in_progress')))])]), _vm._v(" "), _c('div', {
    staticClass: "jobs-desc text-center"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.statusCounts.late))]), _vm._v(" "), _c('span', {
    staticClass: "desc desc-cancelled"
  }, [_vm._v(_vm._s(_vm.getStatusName(5) ? _vm.getStatusName(5) : _vm.$t('calendar.jobs.late')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-15 background-white"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel-content-inner w-full"
  }, [_c('div', {
    staticClass: "row justify-content-between m-t-15"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMember),
      expression: "selectedMember"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMember = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t('calendar.jobs.assign_to')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Unassigned")]), _vm._v(" "), _vm._l((_vm.members), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v(_vm._s(((member.first_name) + " " + (member.last_name))))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 m-t-5"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save apply-btn",
    attrs: {
      "disabled": !_vm.isAtLeastOneTaskChecked
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.assignCheckedTasksToMember()
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('button.apply')) + "\n                          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3 m-t-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-11 date-filter"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('date-picker', {
    attrs: {
      "shortcuts": _vm.shortcuts,
      "range": "",
      "type": "date",
      "width": "225",
      "clearable": false,
      "format": "MMM DD, YYYY",
      "confirm": "",
      "lang": "en"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-15 background-white"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel-content-inner w-full"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "tasks-table"
    }
  }, [_c('div', {}, [_c('h2', [_vm._v(_vm._s(_vm.$t('calendar.tasks.task_management')))]), _vm._v(" "), (_vm.tasks.length > 0) ? _c('table', {
    staticClass: "tasks-table-sizes row-link table table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "task-detail"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allTasksAreChecked),
      expression: "allTasksAreChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allTasksAreChecked) ? _vm._i(_vm.allTasksAreChecked, null) > -1 : (_vm.allTasksAreChecked)
    },
    on: {
      "click": _vm.checkOrUncheckTasks,
      "change": function($event) {
        var $$a = _vm.allTasksAreChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allTasksAreChecked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allTasksAreChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allTasksAreChecked = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "task-status"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('calendar.tasks.status_title')))])]), _vm._v(" "), _c('th', {
    staticClass: "task-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('calendar.tasks.title')))])]), _vm._v(" "), _c('th', {
    staticClass: "task-rental"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('calendar.tasks.rental')))])]), _vm._v(" "), _c('th', {
    staticClass: "task-due-date"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('calendar.tasks.due_date')))])]), _vm._v(" "), _c('th', {
    staticClass: "task-assigned-to"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('calendar.tasks.assigned_to')))])]), _vm._v(" "), _c('th', {
    staticClass: "task-actions"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('calendar.tasks.actions')))])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tasks), function(task) {
    return _c('tr', [_c('td', {
      staticClass: "task-id task-detail"
    }, [_c('div', {
      attrs: {
        "id": "task-id-td"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (task.checked),
        expression: "task.checked"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(task.checked) ? _vm._i(task.checked, null) > -1 : (task.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = task.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(task, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(task, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(task, "checked", $$c)
          }
        }, _vm.checkCheckedTasks]
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "task-action statuses",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editTask(task)
        }
      }
    }, [_c('div', {
      staticClass: "row d-flex justify-content-center"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('span', {
      staticClass: "status-circle",
      class: _vm.getClass(task.assigned_status)
    }, [_vm._v(_vm._s(_vm.getStatusName(task.assigned_status)))])])])]), _vm._v(" "), _c('td', {
      staticClass: "task-rental task-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editTask(task)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(task.title))])]), _vm._v(" "), _c('td', {
      staticClass: "task-checkin task-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editTask(task)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(task.rental.name))])]), _vm._v(" "), _c('td', {
      staticClass: "task-nights task-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editTask(task)
        }
      }
    }, [_c('div', [_vm._v("\n                              " + _vm._s(_vm.getDueDateFormatted(task.due_date)) + "\n                            ")])]), _vm._v(" "), _c('td', {
      staticClass: "task-channel team-members",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editTask(task)
        }
      }
    }, [_c('div', [_vm._v("\n                              " + _vm._s(_vm.getMemberName(task.assigned_to)) + "\n                            ")])]), _vm._v(" "), _c('td', {
      staticClass: "task-actions"
    }, [_c('div', {
      staticClass: "row justify-content-center action-padding pos-rel"
    }, [_c('div', {
      staticClass: "col-6 column-padding"
    }, [_c('div', {
      staticClass: "row action-padding"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "dropdown padding-none dropup"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right add-members"
    }, [_c('ul', {
      staticClass: "add-member-list"
    }, _vm._l((_vm.statuses), function(status) {
      return _c('li', {
        staticClass: "add-member-list-item",
        class: task.assigned_status === status.id ? 'list-selected' : '',
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.changeAssignStatus(task, status.id)
          }
        }
      }, [_vm._v(_vm._s(status.name) + "\n                                          ")])
    }))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "dropdown padding-none dropup"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right add-members"
    }, [_c('ul', {
      staticClass: "add-member-list"
    }, [(task.assigned_to) ? _c('li', {
      staticClass: "add-member-list-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.addOrChangeTeamMember(task)
        }
      }
    }, [_vm._v("Unassign")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.members), function(member) {
      return _c('li', {
        staticClass: "add-member-list-item",
        class: task.assigned_to === member.id ? 'list-selected' : '',
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.addOrChangeTeamMember(task, member.id)
          }
        }
      }, [_vm._v("\n                                            " + _vm._s(((member.first_name) + " " + (member.last_name))) + "\n                                          ")])
    })], 2)])])])])])])])])
  }))]) : _c('div', {
    staticClass: "d-flex justify-content-center mb-10",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "list-rental-empty mt-0"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t('calendar.tasks.no_tasks')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup ",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createTask($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.create")))])])])])])])])])])])])])])]) : _vm._e(), _vm._v(" "), _c('v-create-task', {
    ref: "createTask",
    attrs: {
      "members": _vm.members,
      "rentals": _vm.rentals,
      "editedTask": _vm.editedTask
    },
    on: {
      "getTasks": _vm.getTasks,
      "decreaseCount": _vm.decreaseCount
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "action-icons plus-icon dropdown-toggle ",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "far fa-bars"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "action-icons plus-icon dropdown-toggle ",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "far fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70e752e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/calendar/scheduler/task-management/TaskLists.vue
// module id = 1383
// module chunks = 0